import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Table } from "./Table";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

interface IProps {
    is_Create?: boolean;
    is_Delete?: boolean;
    is_Update?: boolean;
    is_Export?: boolean;
    is_View?: boolean;
    is_Consultant?: boolean;
}

export const ShowPurchaseOrder = (permissions: IProps) => {
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
        const navigate = useNavigate();
    
    const goToDashboard = () => {
        navigate("/dashboard");
    };
    return (
        <>

            <p className="w-full flex justify-content-between pr-2"><span style={{fontWeight: "bold"}}>Purchase Orders</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>
            <Table permissions={permissions} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}
